import * as moment from 'moment'

export class DateFormatValueConverter {
    toView(value: Date) {
        if (value) {
            //A workaround for null dates, which gets set to an actual date.
            //if (typeof value.getMonth === 'function') {
            //    if (value.getTime() === 0) {
            //        return "";
            //    }
                return moment(value).format('MMM Do, YYYY');

            //} else {
            //    return "";
            //}
        }
    }
}